
import { useNavigate } from 'react-router-dom';

export default function FilmHumanitiesSection() {
  const navigate = useNavigate();

  return (
    <section id="film" className="py-16 md:py-24 px-4 md:px-6" style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #2c1654 100%)' }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">

          {/* 왼쪽: 텍스트 콘텐츠 */}
          <div className="flex-1 text-center lg:text-left">
            <span
              className="inline-block px-4 py-1.5 rounded-full text-white text-sm font-bold mb-6"
              style={{ backgroundColor: '#C0392B' }}
            >
              인문학 강좌
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight mb-6">
              영화와 인문학
            </h2>
            <p className="text-lg text-white/80 leading-relaxed mb-8 max-w-xl">
              영화 한 편이 철학 한 권보다 깊을 수 있습니다.<br />
              고전 영화와 현대 영화를 인문학적 시각으로 함께 감상하고 토론합니다.<br />
              철학·역사·심리학을 영화 속 장면과 연결하며 삶의 깊이를 더하는 인문학 강좌입니다.
            </p>

            {/* 태그 */}
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-10">
              {[
                { icon: 'ri-time-line', text: '8주 과정' },
                { icon: 'ri-user-line', text: '성인 누구나' },
                { icon: 'ri-film-line', text: '영화 감상 + 토론' },
                { icon: 'ri-book-open-line', text: '철학·역사·심리학' },
              ].map((tag) => (
                <div
                  key={tag.text}
                  className="flex items-center gap-2 rounded-full px-4 py-2"
                  style={{ backgroundColor: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)' }}
                >
                  <i className={`${tag.icon} text-white/80 text-sm`}></i>
                  <span className="text-white/90 text-sm font-medium">{tag.text}</span>
                </div>
              ))}
            </div>

            {/* 추천 영화 미리보기 */}
            <div className="mb-10">
              <p className="text-white/50 text-xs font-semibold uppercase tracking-widest mb-3">다루는 영화</p>
              <div className="flex flex-wrap gap-2 justify-center lg:justify-start">
                {['매트릭스', '파이트 클럽', '이터널 선샤인', '쉰들러 리스트', '기생충', '밀양'].map((film) => (
                  <span
                    key={film}
                    className="px-3 py-1 rounded-full text-xs font-bold text-white/80"
                    style={{ backgroundColor: 'rgba(192,57,43,0.3)', border: '1px solid rgba(192,57,43,0.5)' }}
                  >
                    {film}
                  </span>
                ))}
              </div>
            </div>

            <button
              onClick={() => navigate('/film-humanities')}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-extrabold text-white text-base hover:opacity-90 hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg"
              style={{ backgroundColor: '#C0392B' }}
            >
              <i className="ri-film-line"></i>
              강좌 자세히 보기
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* 오른쪽: 이미지 카드 */}
          <div className="flex-shrink-0 w-full lg:w-[480px]">
            <div
              className="relative rounded-3xl overflow-hidden shadow-2xl cursor-pointer group"
              style={{ height: '520px' }}
              onClick={() => navigate('/film-humanities')}
            >
              <img
                src="https://static.readdy.ai/image/3c653b3a8a919d24e4f7a2804547f79c/a133d9581e25a5c69acf697d0dfdc3dc.png"
                alt="영화와 인문학"
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%)' }}></div>

              {/* 카드 하단 텍스트 */}
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-3 py-1 rounded-full text-xs font-bold text-white" style={{ backgroundColor: '#C0392B' }}>
                    인문학
                  </span>
                  <span className="text-xs font-medium text-white/70">영화로 읽는 삶과 철학</span>
                </div>
                <h3 className="text-2xl font-extrabold text-white mb-2 drop-shadow-md">영화와 인문학</h3>
                <div className="flex items-center gap-1 text-sm font-semibold text-white/80 group-hover:text-white transition-colors duration-300">
                  <span>자세히 보기</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
